import { Toaster as Sonner, type ToasterProps } from 'sonner';
import { useAtomValue } from 'jotai';
import { themeAtom } from '@/state/atoms';

function Toaster(props: ToasterProps) {
  const theme = useAtomValue(themeAtom);

  return (
    <Sonner
      theme={theme as ToasterProps['theme']}
      className="toaster group"
      style={
        {
          '--normal-bg': 'var(--popover)',
          '--normal-text': 'var(--popover-foreground)',
          '--normal-border': 'var(--border)',
        } as React.CSSProperties
      }
      {...props}
    />
  );
}

export { Toaster };
